"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YesOrNoStr = exports.YesOrNoNum = void 0;
const YesOrNoNum = exports.YesOrNoNum = {
  Yes: 1,
  No: 0
};
const YesOrNoStr = exports.YesOrNoStr = {
  Yes: '1',
  No: '0'
};